import { render, staticRenderFns } from "./editMappingDomain.vue?vue&type=template&id=4509e0ce"
import script from "./editMappingDomain.vue?vue&type=script&lang=js"
export * from "./editMappingDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports